// extracted by mini-css-extract-plugin
export var textContent = "basic-module--textContent--RBD_N";